import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EntityType, EntityTypeLabel, EnumHelper, TimeInBusinessPeriod, TimeInBusinessPeriodLabel } from 'common';
import { businessSectionHeaderConfig } from '../../form-details.data';
import { FormDetailsActionsService } from '../../services/actions/form-details-actions.service';
import { FormDetailsSectionHeaderConfig, FormDetailsSectionHeaderIconType } from '../form-details-section-header/form-details-section-header.model';
import { MatExpansionPanel } from '@angular/material/expansion';

@UntilDestroy()
@Component({
    selector: 'ifbp-business-form',
    templateUrl: './business-form.component.html',
    styleUrls: ['./business-form.component.scss'],
    standalone: false
})
export class BusinessFormComponent implements OnInit {
  @ViewChild('panel') panel: MatExpansionPanel;

  @Input()
  form: FormGroup;

  readonly ownershipOptions = EnumHelper.getMappedNamesAndValues(EntityType, EntityTypeLabel);
  readonly timeInBusinessOptions = EnumHelper.getMappedNamesAndValues(TimeInBusinessPeriod, TimeInBusinessPeriodLabel);
  readonly IconType = FormDetailsSectionHeaderIconType;
  headerConfig: FormDetailsSectionHeaderConfig = businessSectionHeaderConfig;
  canMarkInvalidSection: boolean;

  constructor(private readonly formDetailsActions: FormDetailsActionsService) { }

  ngOnInit(): void {
    this.initActions()
  }

  private initActions(): void {
    this.formDetailsActions.markInvalidSections$
      .pipe(untilDestroyed(this))
      .subscribe((canMarkAsInvalid: boolean) => {
        this.canMarkInvalidSection = canMarkAsInvalid;
        if (canMarkAsInvalid && this.form.invalid) {
          this.panel.open();
        }
      })

    this.formDetailsActions.expandAllSections$
      .pipe(untilDestroyed(this))
      .subscribe(() => this.panel.open());
  }
}
